import { colorsPalettes } from "@similarweb/styles";
import styled from "styled-components";

export const TooltipPartialText = styled.div`
    font-size: 12px;
    line-height: 16px;
    padding: 4px 8px;
    font-weight: 400;
    background: ${colorsPalettes.carbon["50"]};
    border-radius: 4px;
    margin-top: 8px;
`;
